var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 22.246",
    style: {
      enableBackground: "new 0 0 15 22.246"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#666666;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_4046"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.497,22.247l-0.416-0.64c-0.634-0.975-1.239-1.886-1.808-2.743C2.098,14.081,0,10.92,0,7.5 C0,3.364,3.364,0,7.5,0S15,3.364,15,7.5c0,3.533-2.373,7.073-5.657,11.974c-0.46,0.686-0.937,1.396-1.426,2.137L7.497,22.247z  M7.5,1C3.916,1,1,3.916,1,7.5c0,3.119,2.031,6.179,5.106,10.811c0.445,0.671,0.912,1.374,1.397,2.115 c0.344-0.517,0.68-1.02,1.008-1.509C11.698,14.163,14,10.728,14,7.5C14,3.916,11.084,1,7.5,1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLine);
export default __webpack_public_path__ + "static/media/location-line.ca4f9a0f9086e9906ccad057072db058.svg";
export { ForwardRef as ReactComponent };